import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';

@Component({
  selector: 'mstar-generic-delete-dialog',
  templateUrl: './generic-delete-dialog.component.html',
  styleUrls: ['./generic-delete-dialog.component.css']
})
export class GenericDeleteDialogComponent {

  id: number;
  message = 'Confirm Delete';
  message$: Observable<string>;

  constructor(public dialogRef: MatDialogRef<GenericDeleteDialogComponent>, @Inject(MAT_DIALOG_DATA) data: any) {
    if (data) {
      this.id = data.id;

      if (data.message) {
        this.message = data.message;
      }

      if (data.message$) {
        this.message$ = data.message$;
      }
    }
  }

  closeDialog(confirmed: boolean) {
    if (confirmed) {
      this.dialogRef.close(this.id ? this.id : true);
    } else {
      this.dialogRef.close(null);
    }
  }
}
